<template>
  <v-container>
    <v-row>
      <v-col cols="12" align="center">
        <h1>{{ $t("404Title") }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="center">
        <v-img src="../assets/images/page-not-found.jpg" max-width="400" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" align="center">
        <!--        <router-link to="/">{{ $t("404GoToHome") }}</router-link>-->
        <v-btn color="primary" @click="$router.push('/alert')">
          {{ $t("404GoToHome") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NotFound"
};
</script>
